<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      :show-save-button="$permission.canEdit()"
      unit="运费模板"
      edit-title
      id-key="RecordId"
      form-label-width="85px"
      :data="data"
      :form-rules="rules"
      :save-func="() => {}"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="模板名称" prop="TemplateName">
              <el-input
                v-model="data.TemplateName"
                placeholder="请输入模板名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col
            :span="$store.state.isMB ? 24 : 12"
            v-if="loginInfo.UserType == 0"
          >
            <el-form-item
              label="所属商家"
              prop="StoreId"
              :rules="loginInfo.UserType == 0 ? typeRules.StoreId : null"
            >
              <el-select
                v-model="data.StoreId"
                @change="onChange"
                placeholder="请选择商家"
              >
                <el-option
                  v-for="item in busiList"
                  :key="item.RecordId"
                  :label="item.BusiName"
                  :value="item.RecordId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="配送范围" prop="DeliveryRange">
              <el-select
                v-model="data.DeliveryRange"
                placeholder="请选择配送范围"
              >
                <el-option label="异地" :value="0"></el-option>
                <el-option label="本地" :value="1"></el-option>
              </el-select>
              <!-- <el-checkbox v-model="data.OffSite" @change="chkChange('OffSite')">异地</el-checkbox> -->
              <!-- <el-checkbox v-model="data.Innercity" @change="chkChange('Innercity')">本地</el-checkbox> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="配送方式" prop="DeliveryWay">
              <el-select
                v-model="data.DeliveryWay"
                placeholder="请选择配送方式"
              >
                <el-option label="快递" :value="0"></el-option>
                <el-option label="自提" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="描述" prop="Remark">
              <el-input
                type="textarea"
                v-model="data.Remark"
                placeholder="请输入描述"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="是否默认" prop="IsDefault">
              <el-radio-group v-model="data.IsDefault">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="false">
          <el-col :span="24">
            <div class="head">
              <span>不支持配送地区</span>
              <div
                style="display: inline-block; float: right; margin-right: 7px"
              >
                <el-button
                  size="mini"
                  type="primary"
                  @click="adduns"
                  v-if="$permission.canEdit()"
                  >添加</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="deluns"
                  v-if="$permission.canEdit()"
                  >删除</el-button
                >
              </div>
            </div>
            <el-table
              border
              :data="UnSupport"
              @selection-change="change"
              size="mini"
            >
              <el-table-column type="selection" width="35"></el-table-column>
              <el-table-column
                prop="AreaName"
                label="所属区域"
                min-width="250px"
              >
                <!-- <template slot-scope="{row}">
                  <span v-if="row.ProvinceName">{{row.ProvinceName}}</span>
                  <span v-if="row.CityName">/{{row.CityName}}</span>
                  <span v-if="row.DistrictName">/{{row.DistrictName}}</span>
                </template> -->
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row v-if="data.DeliveryWay == 0">
          <el-col :span="24">
            <el-tabs
              v-model="data.Condition"
              class="tabs_box"
              :before-leave="beforeLeave"
              v-if="data.Condition"
            >
              <el-tab-pane label="按数量" name="2"></el-tab-pane>
              <el-tab-pane label="按重量" name="1"></el-tab-pane>
            </el-tabs>
            <div style="margin-top: 20px" v-show="data.DeliveryRange == 1">
              <div class="head">
                <span>本地运费明细</span>
                <div
                  style="display: inline-block; float: right; margin-right: 7px"
                >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="add('Innercity')"
                    v-if="$permission.canEdit()"
                    >添加</el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    plain
                    @click="edit('Innercity')"
                    v-if="$permission.canEdit()"
                    >批量设置</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    @click="del('Innercity')"
                    v-if="$permission.canEdit()"
                    >删除</el-button
                  >
                </div>
              </div>
              <innercity
                ref="Innercity"
                :Condition="String(data.Condition)"
                :DeliveryRange="data.DeliveryRange"
                @detail-save="onEditSave"
              ></innercity>
            </div>
            <div style="margin-top: 20px" v-show="data.DeliveryRange == 0">
              <div class="head">
                <span>异地运费明细</span>
                <div
                  style="display: inline-block; float: right; margin-right: 7px"
                >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="add('OffSite')"
                    v-if="$permission.canEdit()"
                    >添加</el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    plain
                    @click="edit('OffSite')"
                    v-if="$permission.canEdit()"
                    >批量设置</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    @click="del('OffSite')"
                    v-if="$permission.canEdit()"
                    >删除</el-button
                  >
                </div>
              </div>
              <offsite
                ref="OffSite"
                :Condition="String(data.Condition)"
                :DeliveryRange="data.DeliveryRange"
                @detail-save="onEditSave"
              ></offsite>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"> </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
      <district-dialog
        in-dialog
        ref="districtDialog"
        @detail-save="setDistrict"
      />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import innercity from "./innercity/list";
import offsite from "./offsite/list";
import districtDialog from "./districtDialog";
// import busiSelect from "@/components/shop/business/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    innercity,
    offsite,
    districtDialog,
    //busiSelect,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        TemplateName: "",
        DeliveryRange: 0,
        DeliveryWay: 0,
        Remark: "",
        State: 1,
        IsDefault: 0,
        Condition: null,
        StoreId: null,
        // OffSite: true, //异地
        // Innercity: true, //本地
        Supports: [],
        UnSupports: [],
        Weights: [],
        Counts: [],
      },
      tableDel: [],
      select: [],
      UnSupport: [],
      api: require("@/api/sale/freight").default,
      api2: require("@/api/shop/business").default,
      unsApi: require("@/api/sale/freightUnsupport").default,
      rules: {
        TemplateName: [{ required: true, message: "模板名称不能为空" }],
        DeliveryRange: [{ required: true, message: "配送范围不能为空" }],
        DeliveryWay: [{ required: true, message: "配送方式不能为空" }],
        // OrderId: [{ required: true, message: "序号不能为空" }],
      },
      typeRules: {
        StoreId: [{ required: true, message: "请选择所属商家" }],
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      busiList: [],
    };
  },

  computed: {},
  methods: {
    onChange(val) {
      if (this.data.RecordId == 0) {
        this.api.getMaxOrderId(val).then((res) => {
          if (res.Code == 0) this.data.OrderId = res.Data;
        });
      }

      console.log(val, "aa");
    },
    init() {
      this.api2.list({ Status: 1, CheckState: 2 }).then((res) => {
        // console.log(res.Data);
        this.busiList = res.Data;
      });
    },
    onCreateOpened() {
      this.tableDel = [];
      this.UnSupport = [];
      this.init();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
      this.data.Condition = "2";
    },
    onEditSave(data) {
      console.log(data, "ddd");
      if (this.data.Condition == "2") {
        this.data.Counts = data;
      } else if (this.data.Condition == "1") {
        this.data.Weights = data;
      }
    },
    beforeLeave(activeName, oldActiveName) {
      console.log(activeName, oldActiveName, "beforeLeave");
      this.data.Condition = String(activeName);
      console.log(
        this.data.Condition,
        this.data.Weights,
        this.data.Counts,
        "sss"
      );

      if (this.data.DeliveryRange == 0) {
        if (this.$refs.OffSite.data.length > 0) {
          this.data.Condition = oldActiveName;
          this.$message.warning("按数量和按重量只能选择一种");
          return false;
        }
      } else {
        if (this.$refs.Innercity.data.length > 0) {
          this.data.Condition = oldActiveName;
          this.$message.warning("按数量和按重量只能选择一种");
          return false;
        }
      }
      // if (this.data.RecordId > 0) {
      //   this.api.info(this.data.RecordId).then((res) => {
      //     console.log(res, "res");
      //     this.UnSupport = res.Data.UnSupports;
      //     this.$refs.OffSite.setData(res.Data);
      //     this.$refs.Innercity.setData(res.Data);
      //     this.data.Weights = res.Data.Weights;
      //     this.data.Counts = res.Data.Counts;
      //     console.log(
      //       this.data,
      //       "data",
      //       this.data.Counts,
      //       "res.Data.Counts",
      //       res.Data.Counts
      //     );
      //   });
      // }
    },
    // handleClick(tab, event) {
    //   console.log(tab, "tabe");
    //   this.data.Condition = String(tab.name);
    //   console.log(
    //     this.data.Condition,
    //     this.data.Weights,
    //     this.data.Counts,
    //     "sss"
    //   );

    //   if (this.data.RecordId > 0) {
    //     this.api.info(this.data.RecordId).then((res) => {
    //       console.log(res, "res");
    //       this.UnSupport = res.Data.UnSupports;
    //       this.$refs.OffSite.setData(res.Data);
    //       this.$refs.Innercity.setData(res.Data);
    //       this.data.Weights = res.Data.Weights;
    //       this.data.Counts = res.Data.Counts;
    //       console.log(
    //         this.data,
    //         "data",
    //         this.data.Counts,
    //         "res.Data.Counts",
    //         res.Data.Counts
    //       );
    //     });
    //   }
    // },
    onEditOpened(data) {
      this.init();
      this.api.info(data.RecordId).then((res) => {
        this.UnSupport = res.Data.UnSupports;
        if (res.Data.DeliveryWay == 0) {
          if (res.Data.Counts.length > 0) {
            this.data.Condition = "2";
          }
          if (res.Data.Weights.length > 0) {
            this.data.Condition = "1";
          }
          this.$refs.OffSite.setData(res.Data);
          this.$refs.Innercity.setData(res.Data);
        }

        // this.data.Weights = res.Data.Weights;
        // this.data.Counts = res.Data.Counts;
      });
      // if (this.data.OffSite) {
      //   this.$refs.OffSite.setData(this.data.RecordId);
      // }
      // if (this.data.Innercity) {
      //   this.$refs.Innercity.setData(this.data.RecordId);
      // }
      // this.unsApi.list({ RecordId: this.data.RecordId }).then((res) => {
      //   this.UnSupport = res.Data;
      // });
    },
    chkChange(type) {
      if (this.data[type] && this.data.RecordId != 0) {
        this.$refs[type].setData(this.data.RecordId);
      }
    },
    change(rows) {
      this.select = rows;
    },
    adduns() {
      this.$refs.districtDialog.openCreate({
        RecordId: this.data.RecordId,
        filterIds: this.UnSupport.map((x) => x.DistrictId),
      });
    },
    deluns(row, index) {
      if (this.select.length == 0) {
        this.$message.warning("请选择数据");
        return;
      }
      var config = {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      };
      this.$confirm("确认删除吗？", "提示", config)
        .then(() => {
          var ids = this.select.map((x) => x.DistrictId);
          this.UnSupport.forEach((e, i) => {
            if (ids.some((v) => v == e.DistrictId)) {
              if (e.T !== 0) {
                e.T = 2;
                this.tableDel.push(e);
              }
              this.UnSupport.splice(i, 1);
            }
          });
        })
        .catch(() => {});
    },
    setDistrict(data) {
      data.forEach((x) => {
        this.UnSupport.push(x);
      });
    },
    add(ref) {
      console.log(this.data);
      var data = {
        RecordId: this.data.RecordId,
        UnSupport: this.UnSupport,
        Counts: [],
        Weights: [],
      };
      this.$refs[ref].data.forEach((x) => {
        if (this.data.Condition == "2") {
          data.Counts.push(x);
        } else {
          data.Weights.push(x);
        }
      });
      console.log(data, "add");
      this.$refs[ref].add(data);
    },
    edit(ref) {
      this.$refs[ref].edit();
    },
    del(ref) {
      this.$refs[ref].del();
    },
    onBeforeSave() {
      var data = JSON.parse(JSON.stringify(this.data));
      data = this.$commonJs.obj.removeNullKey(data);
      data.Supports = [];
      data.Counts = [];
      if (data.DeliveryWay == 0) {
        this.$refs.OffSite.data.forEach((x) => {
          if (x.T === 0 || x.T === 1) {
            if (data.Condition == "2") {
              data.Counts.push(x);
            } else {
              data.Weights.push(x);
            }
          }
        });
        this.$refs.Innercity.data.forEach((x) => {
          if (x.T === 0 || x.T === 1) {
            if (data.Condition == "2") {
              data.Counts.push(x);
            } else {
              data.Weights.push(x);
            }
          }
        });
      }

      if (this.UnSupport.length > 0) {
        this.UnSupport.forEach((x) => {
          if (x.T === 0 || x.T === 1) {
            data.UnSupports.push(x);
          }
        });
      }
      var counts = [];
      if (data.Counts.length > 0) {
        data.Counts.forEach((x) => {
          if (x.T === 0 || x.T === 1) {
            if (x.RecordId > 0) {
              if (
                counts.filter((w) => w.T === x.T && w.RecordId === x.RecordId)
                  .length == 0
              ) {
                counts.push(x);
              }
            } else {
              if (
                counts.filter(
                  (w) => w.T === x.T && w.DistrictId === x.DistrictId
                ).length == 0
              ) {
                counts.push(x);
              }
            }
          }
        });
        data.Counts = counts;
      }
      var weights = [];
      if (data.Weights.length > 0) {
        data.Weights.forEach((x) => {
          if (x.T === 0 || x.T === 1) {
            if (x.RecordId > 0) {
              if (
                weights.filter((w) => w.T === x.T && w.RecordId === x.RecordId)
                  .length == 0
              ) {
                weights.push(x);
              }
            } else {
              if (
                weights.filter(
                  (w) => w.T === x.T && w.DistrictId === x.DistrictId
                ).length == 0
              ) {
                weights.push(x);
              }
            }
          }
        });
        data.Weights = weights;
      }
      if (data.DeliveryWay == 0) {
        this.$refs.OffSite.tableDel.forEach((x) => {
          if (data.Condition == "2") {
            data.Counts.push(x);
          } else {
            data.Weights.push(x);
          }
        });
        this.$refs.Innercity.tableDel.forEach((x) => {
          if (data.Condition == "2") {
            data.Counts.push(x);
          } else {
            data.Weights.push(x);
          }
        });
      }

      this.tableDel.forEach((x) => {
        data.UnSupports.push(x);
      });
      console.log(data, "bbb");
      this.loading();
      this.api.save(data).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.onClosed();
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      if (this.$refs.OffSite) {
        this.$refs.OffSite.data = [];
        this.$refs.OffSite.tableDel = [];
      }
      if (this.$refs.Innercity) {
        this.$refs.Innercity.data = [];
        this.$refs.Innercity.tableDel = [];
      }

      this.UnSupport = [];
      this.tableDel = [];
      this.select = [];
      this.data.Counts = [];
      this.data.Weights = [];
      this.data.Supports = [];
      this.data.UnSupports = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  line-height: 40px;
  font-weight: bold;
  padding-left: 10px;
  border: 1px solid #ebeef5;
  border-bottom: none;
}
</style>
<style lang="scss">
.tabs_box {
  margin: 0;
  .el-tabs__header {
    margin: 0;
  }
}
</style>